/**
 * pd-cursor-throttle.js
 *
 * Throttles mousemove-driven cursor tracking on the case-study slide
 * navigation halves (.next-an-half / .prev-an-half).
 *
 * main.js attaches unthrottled mousemove listeners that reposition
 * a cursor element on every event tick. This script intercepts those
 * events in the capture phase (before they reach the target handlers)
 * and applies a requestAnimationFrame throttle instead.
 */
(function () {
  'use strict';

  var ticking = false;
  var lastX = 0;
  var lastY = 0;
  var cursorEl = null;

  function getHalfEl(target) {
    var el = target;
    while (el && el !== document) {
      if (
        el.classList &&
        (el.classList.contains('next-an-half') ||
          el.classList.contains('prev-an-half'))
      ) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }

  document.addEventListener(
    'mousemove',
    function (e) {
      var half = getHalfEl(e.target);
      if (!half) return;

      /* Prevent the unthrottled handler in main.js from firing */
      e.stopPropagation();

      lastX = e.clientX;
      lastY = e.clientY;
      cursorEl = half.nextElementSibling;

      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () {
          if (cursorEl) {
            cursorEl.style.left = lastX + 'px';
            cursorEl.style.top = lastY + 'px';
          }
          ticking = false;
        });
      }
    },
    true /* capture phase */
  );
})();
